import script from "./DropdownListSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownListSimple.vue?vue&type=script&setup=true&lang=js"

import "./DropdownListSimple.vue?vue&type=style&index=0&id=64fd60e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.69.1_uglify-js@3.15.2_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64fd60e0"]])

export default __exports__